import { createSlice } from '@reduxjs/toolkit';
import { useSelector, useDispatch } from 'react-redux';

const initialState = {
  currentScreen: '',
  previousScreen: '',
  globalOverlayLoader: false,
  isHypervergeKycLoading: 0, // default page 0, 1 means success screen ,2 = loder
  conOrderDetails: {},
  conEmiData: {},
  isConsentLetter: false,
};

export const consentLetterSlice = createSlice({
  name: 'consentLetter',
  initialState,
  reducers: {
    updateCurrentScreen: (state, action) => {
      state.currentScreen = action.payload;
    },
    updatePreviousScreen: (state, action) => {
      state.previousScreen = action.payload;
    },
    updateGlobalOverlayLoader: (state, action) => {
      state.globalOverlayLoader = action.payload;
    },
    updateHypervergeKycLoading: (state, action) => {
      state.isHypervergeKycLoading = action.payload;
    },
    updateOrderDetails: (state, action) => {
      state.conOrderDetails = action.payload;
    },
    updateEmiDetails: (state, action) => {
      state.conEmiData = action.payload;
    },
    updateIsConsentLetter: (state, action) => {
      state.isConsentLetter = action.payload;
    },
  },
});

export function useConsentLetterStore() {
  const currentScreen = useSelector(
    (state) => state.consentLetter.currentScreen
  );
  const previousScreen = useSelector(
    (state) => state.consentLetter.previousScreen
  );
  const globalOverlayLoader = useSelector(
    (state) => state.consentLetter.globalOverlayLoader
  );
  const isHypervergeKycLoading = useSelector(
    (state) => state.consentLetter.isHypervergeKycLoading
  );
  const conOrderDetails = useSelector(
    (state) => state.consentLetter.conOrderDetails
  );
  const conEmiData = useSelector((state) => state.consentLetter.conEmiData);
  const isConsentLetter = useSelector(
    (state) => state.consentLetter.isConsentLetter
  );

  const dispatch = useDispatch();
  return {
    currentScreen,
    previousScreen,
    globalOverlayLoader,
    isHypervergeKycLoading,
    conOrderDetails,
    conEmiData,
    isConsentLetter,
    updateCurrentScreen: (payload) => dispatch(updateCurrentScreen(payload)),
    updatePreviousScreen: (payload) => dispatch(updatePreviousScreen(payload)),
    updateGlobalOverlayLoader: (payload) =>
      dispatch(updateGlobalOverlayLoader(payload)),
    updateHypervergeKycLoading: (isLoading) =>
      dispatch(updateHypervergeKycLoading(isLoading)),
    updateOrderDetails: (payload) => dispatch(updateOrderDetails(payload)),
    updateEmiDetails: (payload) => dispatch(updateEmiDetails(payload)),
    updateIsConsentLetter: (payload) =>
      dispatch(updateIsConsentLetter(payload)),
  };
}

export const {
  updateCurrentScreen,
  updateOrderDetails,
  updateEmiDetails,
  updatePreviousScreen,
  updateGlobalOverlayLoader,
  updateHypervergeKycLoading,
  updateIsConsentLetter,
} = consentLetterSlice.actions;

export default consentLetterSlice.reducer;
